import { useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { type Translationtype } from "utils";
import type { autoCompleteType } from "./formTypes";

interface IFormInputProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  autoComplete?: autoCompleteType;
  name: string;
  onFocus?: () => void;
  t: Translationtype;
}

export function FormPasswordInput({
  register,
  errors,
  className,
  disabled,
  placeholder,
  autoComplete,
  name,
  onFocus,
  t,
}: IFormInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <div className={`${className || ""} w-full relative`}>
        <input
          id={name}
          onFocus={onFocus?.()}
          disabled={disabled || false}
          type={showPassword ? "text" : "password"}
          autoComplete={autoComplete}
          aria-autocomplete={autoComplete}
          className={`input input-bordered ${disabled ? "!bg-gray-200" : ""} w-full focus:outline-hoverColor bg-white`}
          placeholder={placeholder || ""}
          {...register(name)}
        />
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
        >
          {showPassword ? <BsEyeSlash size={20} /> : <BsEye size={20} />}
        </button>
      </div>
      {errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
